import React from "react";
import Grid from "@material-ui/core/Grid";
import Navbar from "../components/Navbar"
import Map1 from "../components/Map1Components/Map1"

export default function Project1() {

    return (
      <Grid container>
        <Grid item xs={12}>
          <Navbar />
        </Grid>
        <Grid item xs={12}>
          <Map1 />
        </Grid>
      </Grid>
    );
}